/**
 * @file 问题模板组件
 */
import React from 'react';
import styles from './QuestionContainer.module.less';
import {useMembershipTracking} from './hooks/useMembershipTracking';
import {TrackEvents} from '@/services/tracking/constant';
import {createCx} from '@/utils/cx';
import type {QuestionInfo} from '@/services/commerce/membership/interface';
import Icon from '@/components/common/Icon';

const cx = createCx(styles);

/**
 * 单个问题项组件 - 独立管理自己的展开状态
 * 每个问题项有自己的状态，不需要父组件管理
 */
const QuestionItem: React.FC<QuestionInfo & {index: number}> = ({question, answer, index}) => {
    const [expanded, setExpanded] = React.useState(false);
    const {sendClickLog} = useMembershipTracking();

    const toggleExpand = () => {
        setExpanded((prev) => {
            if (!prev) {
                sendClickLog({
                    value: TrackEvents.MEMBERSHIP_MODAL_FAQ_EXPAND_BTN,
                    ext: {
                        // eslint-disable-next-line camelcase
                        question_id: index + 1,
                    },
                });
            }
            return !prev;
        });
    };

    return (
        <div className={cx('faqItem')}>
            <div className={cx('question')} onClick={toggleExpand}>
                <span className={cx('questionText')}>{question}</span>
                <Icon name="AijBasicXia" size={20} className={cx('arrow', {expanded})} />
            </div>
            <ul className={cx('answer', {visible: expanded})}>
                {answer?.map((answerItem) => (
                    <li key={answerItem} className={cx('answerItem')}>
                        {answerItem}
                    </li>
                ))}
            </ul>
        </div>
    );
};

interface QuestionContainerProps {
    faqs: QuestionInfo[];
}

/**
 * 问题容器组件
 * 展示常见问题列表，每个问题可独立展开/收起
 */
export const QuestionContainer: React.FC<QuestionContainerProps> = ({faqs = []}) => {
    return (
        <div className={cx('questionContainer')}>
            <div className={cx('title')}>常见问题</div>
            <div className={cx('desc')}>退款政策、权益说明、续费规则等问题答疑</div>
            <div className={cx('faqList')}>
                {faqs.map((faq, index) => (
                    <QuestionItem
                        key={faq.question}
                        question={faq.question}
                        answer={faq.answer}
                        index={index}
                    />
                ))}
            </div>
        </div>
    );
};

export default QuestionContainer;
